import { Injectable } from '@angular/core';

export class ExchangeRateEF {
  IdentityColumn: number;
  lFromCurrencyId?: number;
  lToCurrencyId?: number;
  ConversionRate?: number;
  RateDate?: Date;
  FromCurrency: string;
  ToCurrency: string;
}

export class SystemSetting {
  lSystemSettingId: number;
  lBaseOurEntityId: number;
  lBaseCurrencyId: number;
  lBaseUnitId: number;
  IsLimitMaxed: number;
  ValuationDate: Date;
  IsCalendarLimit: number;
  IsParentEntityLimitValidated: number;
  IsFourEyePolicyforCallMemoEnabled: number
  IsLimitDateWarned: number
  lParentLimitEntityId: number;
  RegulationValuationDate: Date;
  IsNettingTypeLimitStructure: number
  IsOverallLimitEditable: number
  IsSumOurEntityLimit: number;
  IsVolumeLimitEnabled: number;
  IsCalendarVolumeLimit: number
  DisableLCLimitDateValidation: number;
  IsEntityLimitValidated: number;
  IsCounterPartyLimitValidated: number;
  IsDisabledCptysIncludedInLimit: number;
  IsOverAllLimitValidated: number;
  IsCompleteHeirarchyLoadedByDefault: number;// FB31641 - pawan prajapati - 12/10/2021
}

export class TradingCounterpartyLegalHierarchyOwnership {
  IdentityColumn: number;
  lLegalHierarchyTradingCounterpartyId?: number;
  lParentTradingCounterpartyId?: number;
  ParentTradingCounterparty: string;
  lChildTradingCounterpartyId?: number;
  ChildTradingCounterparty: string;
  IsChildrenHierarchy: number;
  Level?: number;
  OwnershipPercentage: number;
  Hierarchy: string;
  HierarchyAlpha: string;
  ID: string;
  TradingCounterpartyLegalHierarchyOwnershippings?: TradingCounterpartyLegalHierarchyOwnership[];
  TradingCounterpartyLegalHierarchyOwnershipForUltimateIds?: TradingCounterpartyLegalHierarchyOwnership[];
  TradingCounterpartys?: TradingCounterparty[];
}

export class TradingLimitLine {

  lTradingLimitLineId: number;

  Period: string;

  lTradingCounterpartyId: number;

  lOurEntityId: number;

  lTradingCategoryId: number;

  LimitValue: number;

  lLimitValueCurrencyId: number;


  StartDate: Date;
  EndDate: Date;

  LimitValue1?: number;

  lLimitTypeId?: number;

  HeadRoomLimit?: number;

  lHeadRoomCurrencyId?: number;

  LimitStartDate?: Date;

  LimitEndDate?: Date;
}

export class Test {
  Id: number;
  Name: string;
}


export class TradingLimit {

  lTradingLimitId: number;

  lTradingCounterpartyId: number;

  lOurEntityId: number;

  lLimitTypeId: number;

  lTradingCategoryId?: number;

  LimitValue: number;

  lLimitValueCurrencyId: number;

  lTenorTypeId: number;

  Period?: number;

  lPeriodTypeId?: number;

  LimitStartDate?: Date;

  LimitEndDate?: Date;

  BUY: number;

  SELL: number;

  lSubLimitTypeId: number

  lTradingProductId?: number

  EntityState: number

  TradingLimitComments: TradingLimitComment[]
}

export class TradingLimitComment {
  lTradingLimitCommentId: number
  TradingLimitCommentName: string
  lTradingLimitId: number
}
export class Unit {
  lUnitId: number;
  UnitName: string;
  Description: string;
  BaseConversionRate?: number;
}


export class TradingCounterpartyLimit {
  lTradingCounterpartyId: number;

  lOurEntityId: number;

  lTradingCategoryId: number;

  lLimitTypeId: number;

  lLimitCurrencyId: number;

  StartDate: Date;

  EndDate: Date;

  LimitValue: number;

  lTradingCounterpartyLimitId: number;

  lOverallLimitSettingId: number;

  IsAutoRollOver: boolean;

  LastReviewDate: Date;

  NextReviewDate: Date;

  ForwardLimitMonth: number;

  EntityState: number;

  //get AutoRollOver(): boolean {
  //  if (this.IsAutoRollOver == 0)
  //    return false;
  //  else
  //    return true;    
  //}
  //set AutoRollOver(IsAutoRollOver: boolean) {
  //  if (IsAutoRollOver == true)
  //    this.IsAutoRollOver = 1
  //  else
  //    this.IsAutoRollOver = 0
  //}

  //get DisableExpiryDate(): boolean {
  //  //if (this.IsAutoRollOver == 0)
  //  //  return false;
  //  //else
  //    return false;
  //}


}


export class TradingLimitWithComment {

  lTradingLimitId: number;

  lTradingCounterpartyId: number;

  lOurEntityId: number;

  lLimitTypeId?: number;

  lTradingCategoryId: number;

  LimitValue: number;

  lLimitValueCurrencyId: number;

  lTenorTypeId: number;
  StartPeriod?: number;
  Period: number;

  lPeriodTypeId: number;

  LimitStartDate?: Date;

  LimitEndDate?: Date;

  BUY: number;

  SELL: number;

  lSubLimitTypeId?: number

  lTradingProductId?: number

  lTradingLimitCommentId: number;

  TradingLimitComment?: string

  EntityState: number

  lTradingCounterpartyLimitId: number;

  TradingCounterpartyLimit: TradingCounterpartyLimit;

  lUnitId?: number;

  DataValue: string;

  /*Start FB 25503 - Vidya*/
  DataValueForStartPeriod: string;

  DataValueForToPeriod: string;
  /*End FB 25503 - Vidya*/

  lUnVerifiedDataEntityId: number;

  lDataEntityId: number;

  lDataInstanceId: number;

  lAmendedById: number;

  AmendedOn: Date;

  lVerifiedById?: number;

  VerifiedOn?: Date;

  Status: number;

  lUnVerifiedDataEntityFieldId: number;

  /*Start FB 25503 - Vidya*/
  lUnVerifiedDataEntityFieldIdForToPeriod: number;

  lUnVerifiedDataEntityFieldIdForStartPeriod: number;
  /*End FB 25503 - Vidya*/

  lDataEntityFieldNameId: number;

  /*Start FB 25503 - Vidya*/
  lDataEntityFieldNameIdForStartPeriod: number;

  lDataEntityFieldNameIdForToPeriod: number;

  DataValueWithFourEye: string;
  /*End FB 25503 - Vidya*/

  User: string;
  CustomPropertyValues?: any[];
}


export class TradingCounterpartyPCGHierarchyEF {
  lTradingCounterpartyPCGHierarchyId: number;
  lParentCounterpartyGuaranteeId: number;
  lParentCounterpartyId: number;
  Parent: string;
  lChildCounterpartyId: number;
  Child: string;
  lOurEntityId: number;
  TradingEntity: string;
  OverAllLimit: number;
  OverAllLimitCurrency: string;
  lTradingEntityId: number;
  Header: string;
  ID: string;
  TradingCounterpartyPCGHierarchyEFs?: TradingCounterpartyPCGHierarchyEF[]
}

export class TradingEntityLegalHierarchyOwnership {
  IdentityColumn: number;
  lLegalHierarchyTradingEntityId?: number;
  lParentTradingEntityId?: number;
  ParentTradingEntity: string;
  lChildTradingEntityId?: number;
  ChildTradingEntity: string;
  IsChildrenHierarchy: number;
  Level?: number;
  OwnershipPercentage: number;
  Hierarchy: string;
  HierarchyAlpha: string;
  ID: string;
  TradingEntityLegalHierarchyOwnershippings?: TradingEntityLegalHierarchyOwnership[];
  TradingEntityLegalHierarchyOwnershipForUltimateIds?: TradingEntityLegalHierarchyOwnership[];
  TradingEntitys?: TradingEntity[];
}

export class TradingCounterparty {
  lTradingCounterpartyId: number;
  TradingCounterpartyName: string;
  lParentTradingCounterpartyId: number;
  Enabled: boolean;
}

export class TradingEntity {
  lTradingEntityId: number;
  TradingEntityName: string;
  lParentTradingEntityId: number;
  Enabled: boolean;
}

export class TradingCategory {
  lTradingCategoryId: number;
  TradingCategoryName: string;
  IsEnabled: number;
  lTradeNettingContractTypeId?: number;
  lDefaultLimitCurrencyId?: number;
  IsOverall: number;
  lParentTradingCategoryId?: number;
  TradingCategoryLevel?: number;
}

export class LimitType {
  lLimitTypeId: number;
  LimitTypeName: string;
}


export class TenorType {
  lTenorTypeId: number;
  TenorTypeName: string;
}

export class PeriodType {
  lPeriodTypeId: number;
  PeriodTypeName: string;
}

export class Currency {
  lCurrencyId: number;
  CurrencyName: string;
}


export class TradingProduct {
  lTradingProductId: number;
  TradingProductName: string;
  IsEnabled: number;
}

export class SubLimitType {
  lSubLimitTypeId: number;
  SubLimitTypeName: string;
}

export class TradingcounterpartySearchView {
  lTradingCounterpartyId: number;

  TradingCounterparty: string;

  LongName: string;

  Description: string;

  DunsNumber: string;

  CPCode: string;

  LEI: string;

  EntityIdentificationCode: string;

  TradingCounterpartyWithCR: string;
}

export class UnVerifiedDataEntityWithField {

  lUnVerifiedDataEntityId: number;
  lDataEntityId: number;
  lDataInstanceId: number;
  lAmendedById: number;
  AmendedBy: string;
  AmendedOn: Date;
  lVerifiedById?: number;
  VerifiedBy: string;
  VerifiedOn?: Date;
  Status: number;
  lUnVerifiedDataEntityFieldId: number;
  lDataEntityFieldNameId: number;
  DataValue: string;
}

export class UnVerifiedDataEntity {

  lUnVerifiedDataEntityId: number;
  lDataEntityId: number;
  lDataInstanceId: number;
  lAmendedById: number;
  AmendedOn: Date;
  lVerifiedById?: number;
  VerifiedOn?: string;
  Status: number;
  UnVerifiedDataEntityField: UnVerifiedDataEntityField[];
  EntityState: number;
}

export class UnVerifiedDataEntityField {

  lUnVerifiedDataEntityFieldId: number;
  lUnVerifiedDataEntityId: number;
  lDataEntityFieldNameId: number;
  DataValue: string;
  EntityState: number;
}

export class UserRoleMapView {
  lUserRoleMapId: number;
  lUserId: number;
  User: string;
  UserRole: string;
  Email: string;
}

export class DataEntityFieldName {
  lDataEntityFieldNameId: number;
  lDataEntityId: number;
  DatabaseFieldName: string;
  UserFriendlyName: string;
  DatabaseFieldType: string;
  BusinessDataType: string;
  lReferencialDataEntityId?: number;
  IsFourEyePolicyEnabled: number;
  IsMandatory: number;
  IsIdentity: number;
  IsUseInFilterCriteria: number;
  EntityPropertyName: string;
  IsUnique: number;
  IsReadOnly: number;
  IsShownInGrid: number;

}
